/**
 * Shared service-award ladder.
 *
 * Kept in one file so the row chip, trophy case, badge detail, celebration, and
 * badge-testing panel cannot drift apart on names or milestones.
 *
 * Long-service names are deliberately literal rather than playful. "Legend" and
 * "Wizard" read as novelty copy on an HR-facing profile; year-based labels say
 * exactly what was reached and age much better as the ladder extends.
 */

export const SERVICE_AWARDS = [
  { tier: 0, years: 0, label: '0-1 Years', name: 'Just Started', title: 'Welcome aboard', description: 'Welcome to the team' },
  { tier: 1, years: 2, label: '2-4 Years', name: 'Rising Star', title: 'Two years', description: 'Two years in' },
  { tier: 2, years: 5, label: '5-9 Years', name: 'Established', title: 'Five years', description: 'Five years of dedication' },
  { tier: 3, years: 10, label: '10-14 Years', name: 'Senior', title: 'Ten years', description: 'A decade of excellence' },
  { tier: 4, years: 15, label: '15-19 Years', name: 'Expert', title: 'Fifteen years', description: 'Fifteen years of expertise' },
  { tier: 5, years: 20, label: '20-24 Years', name: 'Veteran', title: 'Twenty years', description: 'Two decades of leadership' },
  { tier: 6, years: 25, label: '25-29 Years', name: 'Legend', title: 'Twenty-five years', description: 'Quarter century of impact' },
  { tier: 7, years: 30, label: '30-34 Years', name: 'Luminary', title: 'Thirty years', description: 'Three decades of guidance and influence' },
  { tier: 8, years: 35, label: '35-39 Years', name: 'Wizard', title: 'Thirty-five years', description: 'Thirty-five years of mastery' },
  { tier: 9, years: 40, label: '40+ Years', name: 'Mythic', title: 'Forty years', description: 'Four decades of extraordinary service' },
];

export const SERVICE_MILESTONES = SERVICE_AWARDS.map((award) => award.years);

export function getServiceAwardByTier(tier) {
  if (!Number.isFinite(tier) || tier < 0) return SERVICE_AWARDS[0];
  return SERVICE_AWARDS[Math.min(Math.floor(tier), SERVICE_AWARDS.length - 1)];
}

export function getServiceAwardByYears(years) {
  const value = Number.isFinite(years) ? years : 0;
  return [...SERVICE_AWARDS].reverse().find((award) => value >= award.years) || SERVICE_AWARDS[0];
}
